import { UsuarioModel } from './../usuario/usuario.model';
export class TipoClienteModel {
  id: number;
  descricao: string;
  usuario: UsuarioModel;
};



// WEBPACK FOOTER //
// /app/src/app/model/cliente/tipocliente.model.ts